/*
 *  Copyright (C) 2019 schroeder.org - All Rights Reserved
 *  Unauthorized copying of this file or deriving works therefrom,
 *  via any medium, is strictly prohibited
 *  Proprietary and confidential
 *  <dev@schroeder.org>
 */

import Vue from 'vue';
import IDict, {
  DictWordStatus, IDictGroup, IDictLesson, IDictWord,
} from '@/types/IDict';
import IWord from '@/types/IWord';
import IWordFilter, { IWordFilterData } from '@/types/IWordFilter';

export default class WordFilter {
  // filter to enabled words and extract values
  static filterWords(dict: IDict): IWord[] {
    let words: IWord[] = [];

    Object.keys(dict).forEach((g) => {
      const group: IDictGroup = dict[g];
      Object.keys(group).forEach((l) => {
        const lesson: IDictLesson = group[l];
        Object.keys(lesson).forEach((word) => {
          if (lesson[word].status === DictWordStatus.enabled) {
            words = words.concat({ group: g, lesson: l, word });
          }
        });
      });
    });

    return words;
  }

  // generate object suitable for word filter UI component
  static dictToFilter(dict: IDict): IWordFilter {
    const filter: IWordFilter = {
      dataSource: [],
      id: 'id',
      parentID: 'parentID',
      text: 'text',
      hasChildren: 'hasChildren',
    };

    // put "all" node at top of tree
    let index = 0;
    const allFilterData: IWordFilterData = {
      id: index,
      text: 'Alles',
      hasChildren: true,
      expanded: true,
    };
    filter.dataSource.push(allFilterData);
    const allIndex = index;
    index += 1;

    // iterate over dictionary, create filter data
    // start with everything selected and expanded to lesson level
    Object.keys(dict).sort().forEach((g) => {
      const group: IDictGroup = dict[g];
      const groupFilterData: IWordFilterData = {
        id: index,
        parentID: allIndex,
        text: g,
        hasChildren: true,
        expanded: true,
      };
      filter.dataSource.push(groupFilterData);
      const groupIndex = index;
      index += 1;
      let hasWords = false;

      Object.keys(group).sort().forEach((l) => {
        const lesson: IDictLesson = group[l];
        const lessonFilterData: IWordFilterData = {
          id: index,
          parentID: groupIndex,
          text: l,
          hasChildren: true,
          expanded: false,
        };
        filter.dataSource.push(lessonFilterData);

        const lessonIndex = index;
        index += 1;
        hasWords = false;

        Object.keys(lesson).forEach((word) => {
          if (lesson[word].status === DictWordStatus.removed) {
            return;
          }

          const wordFilterData: IWordFilterData = {
            id: index,
            parentID: lessonIndex,
            text: word,
            hashCode: lesson[word].hashCode,
            hasChildren: false,
            isChecked: lesson[word].status === DictWordStatus.enabled,
          };
          filter.dataSource.push(wordFilterData);
          index += 1;

          hasWords = true;
        });

        if (!hasWords) {
          filter.dataSource.pop();
        }
      });

      if (!hasWords) {
        filter.dataSource.pop();
      }
    });

    Vue.$log('filter', filter.dataSource);
    return filter;
  }

  static applyFilter(dict: IDict, hashes: number[]): void {
    Object.keys(dict).sort().forEach((g) => {
      const group: IDictGroup = dict[g];

      Object.keys(group).sort().forEach((l) => {
        const lesson: IDictLesson = group[l];

        Object.keys(lesson).forEach((w) => {
          const word: IDictWord = lesson[w];
          if (word.status !== DictWordStatus.removed) {
            word.status = hashes.includes(word.hashCode)
              ? DictWordStatus.enabled : DictWordStatus.disabled;
          }
        });
      });
    });
  }
}
